import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const features = [
  {
    title: "Instant Quotes",
    description: "Compare live quotes from multiple verified logistics providers within seconds.",
  },
  {
    title: "Real-Time Tracking",
    description: "Track your move or delivery in real-time with map integration and status updates.",
  },
  {
    title: "Verified Service Providers",
    description: "All transporters on our platform are KYC-verified, trusted, and rated by real users.",
  },
  {
    title: "Secure Payments",
    description: "Enjoy flexible and secure payment methods with payment protection.",
  },
  {
    title: "24/7 Support",
    description: "Our support team is available round-the-clock to help you before, during, and after the move.",
  },
];

const VerticalSlideFeatures = () => {
  const [current, setCurrent] = useState(0);

  const next = () => setCurrent((prev) => (prev + 1) % features.length);
  const prev = () => setCurrent((prev) => (prev - 1 + features.length) % features.length);

  return (
    <section className="bg-light text-dark py-20 px-4 md:px-10">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10">
        {/* Terminal / Code-like Display */}
        <div className="bg-[#0d1b2a] text-white rounded-2xl shadow-xl w-full md:w-1/2 p-6 min-h-[350px] relative">
          <div className="flex gap-2 mb-4">
            <span className="w-3 h-3 bg-red-500 rounded-full" />
            <span className="w-3 h-3 bg-yellow-400 rounded-full" />
            <span className="w-3 h-3 bg-green-500 rounded-full" />
          </div>
          <div className="text-sm text-[#7ae6ff] font-mono">
            {`~ Tiranga > features --demo`}
          </div>
          <div className="h-full flex items-center justify-center text-2xl font-bold text-white opacity-20">
            {features[current].title}
          </div>
        </div>

        {/* Vertical Slide Panel */}
        <div className="relative w-full md:w-1/2 max-h-[300px] overflow-hidden">
          <div className="text-primary text-3xl font-semibold mb-6">Key Features</div>

          <AnimatePresence mode="wait">
            <motion.div
              key={features[current].title}
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -50, opacity: 0 }}
              transition={{ duration: 0.5 }}
              className="text-dark text-left bg-white p-6 rounded-xl shadow"
            >
              <h3 className="text-xl font-bold text-[#004182] mb-2">{features[current].title}</h3>
              <p className="text-neutral-800 text-md">{features[current].description}</p>
            </motion.div>
          </AnimatePresence>

          {/* Navigation Buttons */}
          <div className="flex justify-between mt-6">
            <button
              onClick={prev}
              className="text-[#004182] hover:text-blue-500 text-lg font-bold"
            >
              ◀ Prev
            </button>
            <button
              onClick={next}
              className="text-[#004182] hover:text-blue-500 text-lg font-bold"
            >
              Next ▶
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VerticalSlideFeatures;
